import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const CopyCard = ({ title, content, icon }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col h-full">
      <div className="bg-gray-50/80 px-5 py-3 border-b border-gray-100 flex items-center justify-between">
        <div className="flex items-center gap-2 text-gray-700 font-medium">
          <SafeIcon icon={icon} className="text-emerald-600" />
          {title}
        </div>
        <button
          onClick={handleCopy}
          className={`text-xs font-medium px-3 py-1.5 rounded-md flex items-center gap-1.5 transition-all
            ${copied 
              ? 'bg-green-100 text-green-700 border border-green-200' 
              : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 hover:text-emerald-600'
            }`}
        >
          {copied ? (
            <>
              <SafeIcon icon={FiIcons.FiCheck} /> Copiado
            </>
          ) : (
            <>
              <SafeIcon icon={FiIcons.FiCopy} /> Copiar
            </>
          )}
        </button>
      </div>
      <div className="p-5 flex-grow bg-white">
        <p className="text-gray-700 whitespace-pre-wrap text-sm leading-relaxed font-sans">
          {content}
        </p>
      </div>
    </div>
  );
};

export default CopyCard;